<div class="wrapper">
  <div class="l-container page">
    <div class="page_img">
      <svg
        width="226px"
        height="226px"
        viewBox="0 0 226 226"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Network-Failed" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="VET_VF_Network-Error" transform="translate(-594.000000, -223.000000)">
            <g id="Group-2" transform="translate(559.000000, 161.000000)">
              <g
                id="Group"
                transform="translate(161.573900, 161.573900) rotate(45.000000) translate(-161.573900, -161.573900) translate(33.073900, 61.573900)"
              >
                <rect
                  id="Rectangle-Copy"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="122.496441"
                  y="54.1690391"
                  width="11.2348754"
                  height="101.626335"
                ></rect>
                <rect
                  id="Rectangle-Copy-3"
                  stroke="#979797"
                  stroke-width="2"
                  fill="#D8D8D8"
                  x="127.690391"
                  y="19.5053381"
                  width="1"
                  height="102.626335"
                ></rect>
                <rect
                  id="Rectangle-Copy-3"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#E2001A"
                  x="128.190391"
                  y="20.0053381"
                  width="1"
                  height="101.626335"
                ></rect>
                <path
                  d="M124.631673,68.4039146 L124.631673,170.030249 L135.866548,170.030249 L135.866548,68.4039146 L124.631673,68.4039146 Z"
                  id="Rectangle-Copy-4"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  transform="translate(130.249110, 119.217082) rotate(90.000000) translate(-130.249110, -119.217082) "
                ></path>
                <polygon
                  id="Rectangle-Copy-4"
                  fill="#960011"
                  transform="translate(128.113879, 119.217082) rotate(90.000000) translate(-128.113879, -119.217082) "
                  points="126.690391 66.9039146 129.537367 66.9039146 129.537367 171.530249 126.690391 171.530249"
                ></polygon>
                <circle id="Oval" stroke="#960011" stroke-width="3" fill="#F6F6F6" cx="128.469751" cy="17.4377224" r="3.91459075"></circle>
                <path
                  d="M140.020544,186.791584 L140.020544,175.481465 L151.746573,156.660142 L104.481185,156.660142 L116.207214,175.481465 L116.207214,186.791584 L116.210842,186.939386 C116.36843,193.36043 121.64738,198.5 128.113879,198.5 C134.580378,198.5 139.859328,193.36043 140.016916,186.939386 L140.020544,186.791584 Z M113.207214,176.339539 L113.207214,175.910502 L113.434084,176.703685 L113.207214,176.339539 Z"
                  id="Combined-Shape"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                ></path>
                <path
                  d="M140.047155,187.976868 L116.892347,187.976868 C117.609172,193.91578 122.526853,198.5 128.469751,198.5 C134.412649,198.5 139.33033,193.91578 140.047155,187.976868 Z"
                  id="Oval"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#E2001A"
                ></path>
                <rect
                  id="Rectangle"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#E2001A"
                  x="103.279359"
                  y="68.4039146"
                  width="49.6690391"
                  height="101.626335"
                ></rect>
                <rect
                  id="Rectangle"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#E2001A"
                  x="94.0266904"
                  y="82.63879"
                  width="68.1743772"
                  height="73.1565836"
                ></rect>
                <rect
                  id="Rectangle"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#960011"
                  x="115.379004"
                  y="103.991103"
                  width="25.4697509"
                  height="30.4519573"
                ></rect>
                <rect
                  id="Rectangle-Copy-5"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="175.16548"
                  y="89.7562278"
                  width="27.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-20"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="1.5"
                  y="89.7562278"
                  width="27.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-18"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="202.211744"
                  y="89.7562278"
                  width="25.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-21"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="28.5462633"
                  y="89.7562278"
                  width="25.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-19"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="227.258007"
                  y="89.7562278"
                  width="27.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-22"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="53.5925267"
                  y="89.7562278"
                  width="27.4697509"
                  height="58.9217082"
                ></rect>
                <rect
                  id="Rectangle-Copy-20"
                  stroke="#960011"
                  stroke-width="3"
                  x="1.5"
                  y="119.649466"
                  width="79.5622776"
                  height="29.0284698"
                ></rect>
                <rect
                  id="Rectangle-Copy-23"
                  stroke="#960011"
                  stroke-width="3"
                  x="175.16548"
                  y="119.649466"
                  width="79.5622776"
                  height="29.0284698"
                ></rect>
                <path
                  d="M157.180875,29.2580071 L99.0468827,29.2580071 C99.8275371,44.63514 112.542724,56.8629893 128.113879,56.8629893 C143.685034,56.8629893 156.400221,44.63514 157.180875,29.2580071 Z"
                  id="Oval"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#E2001A"
                ></path>
                <rect
                  id="Rectangle-Copy"
                  stroke="#960011"
                  stroke-width="3"
                  fill="#F6F6F6"
                  x="96.8736655"
                  y="27.1227758"
                  width="62.480427"
                  height="3.69395018"
                ></rect>
                <circle id="Oval" fill="#F6F6F6" cx="137.366548" cy="119.572954" r="1.42348754"></circle>
                <rect id="Rectangle" fill="#960011" x="127.402135" y="0" width="2.13523132" height="9.25266904"></rect>
                <polygon
                  id="Rectangle-Copy-6"
                  fill="#960011"
                  transform="translate(137.393935, 8.781606) rotate(45.000000) translate(-137.393935, -8.781606) "
                  points="136.448617 4.02621097 138.351256 4.02381018 138.339252 13.5370017 136.436614 13.5394025"
                ></polygon>
                <polygon
                  id="Rectangle-Copy-24"
                  fill="#960011"
                  transform="translate(118.819804, 8.781606) scale(-1, 1) rotate(45.000000) translate(-118.819804, -8.781606) "
                  points="117.874486 4.02621097 119.777125 4.02381018 119.765121 13.5370017 117.862482 13.5394025"
                ></polygon>
                <polygon
                  id="Rectangle-Copy-25"
                  fill="#960011"
                  transform="translate(116.370107, 17.437722) scale(-1, 1) rotate(90.000000) translate(-116.370107, -17.437722) "
                  points="115.302491 12.8113879 117.437722 12.8113879 117.437722 22.0640569 115.302491 22.0640569"
                ></polygon>
                <polygon
                  id="Rectangle-Copy-26"
                  fill="#960011"
                  transform="translate(139.857651, 17.437722) scale(-1, 1) rotate(90.000000) translate(-139.857651, -17.437722) "
                  points="138.790036 12.8113879 140.925267 12.8113879 140.925267 22.0640569 138.790036 22.0640569"
                ></polygon>
              </g>
              <rect id="Rectangle" x="0" y="0" width="323" height="323"></rect>
            </g>
          </g>
        </g>
      </svg>
    </div>

    <div class="page_text">
      <h2 class="rc-title-beta page_text-title" i18n="@@error-page_title">Connection Failed</h2>
      <p i18n="@@error-page_description">Could not connect to the network, please check and try again.</p>
      <div class="page_btn-group">
        @if (retryButton) {
          <rc-button data-qa="vs-pet-record-no-content-button-retry" variant="primary" (click)="retry()">
            {{ 'action_retry' | translateKey }}
          </rc-button>
          <ng-container i18n="@@or-key">or</ng-container>
        }
        <rc-button data-qa="vs-pet-record-no-content-button-logout" variant="secondary-alt" (click)="logout()">
          {{ 'action_logout' | translateKey }}
        </rc-button>
      </div>
    </div>
  </div>
</div>
